import { VYSION_ACTIONS } from '..';
import { EventData, handleVysionEvent } from '../vysionService';
import { discoverModeClickVysionEvents } from './click';

export const events = {
  [VYSION_ACTIONS.CLICK]: { ...discoverModeClickVysionEvents },
};

export const handleDiscoverModeVysionEvent = (data: EventData): void => {
  handleVysionEvent<typeof events>(data, events);
};
